function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getScrollY, getScreenBounds } from './DOM';
import log from './log';

var OnScrollTo =
/*#__PURE__*/
function () {
  function OnScrollTo(getElement, onScrollTo, onStateChange, options) {
    var _this = this;

    _classCallCheck(this, OnScrollTo);

    _defineProperty(this, "onScroll", function () {
      return _this.onCheckScrollStatus({
        reason: 'scroll'
      });
    });

    _defineProperty(this, "onResize", function () {
      return _this.onCheckScrollStatus({
        reason: 'resize'
      });
    });

    _defineProperty(this, "onIntersectViewport", function (entries, observer) {
      var isIntersecting = entries[0].isIntersecting;

      if (isIntersecting) {
        _this.onScrollTo();
      }
    });

    _defineProperty(this, "onResult", function (hasMore) {
      if (hasMore === true) {
        _this.enable();
      } else {
        _this.hide();
      }
    });

    _defineProperty(this, "onError", function (error) {
      console.error(error);

      _this.setState({
        error: error
      });
    });

    this.getElement = getElement;
    this._onScrollTo = onScrollTo;
    this.onStateChange = onStateChange;
    this.options = _objectSpread({}, options);

    if (this.options.distance === undefined) {
      // The default trigger distance is the screen height.
      this.options.distance = typeof window === 'undefined' ? 0 : window.innerHeight;
    }

    this.state = {};
    log('~ Initialize ~');
    log('Distance', this.options.distance);
  }

  _createClass(OnScrollTo, [{
    key: "onMount",
    value: function onMount() {
      this.isMounted = true;
      log('Mounted');

      if (window.IntersectionObserver) {
        var distance = this.options.distance; // Every modern browser except Internet Explorer supports `IntersectionObserver`s.
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        // https://caniuse.com/#search=IntersectionObserver

        this.intersectionObserver = new IntersectionObserver(this.onIntersectViewport, {
          root: null,
          // top, right, bottom, left.
          rootMargin: "".concat(distance, "px 0px ").concat(distance, "px 0px"),
          threshold: 0
        });
        this.intersectionObserver.observe(this.getElement());
      } else {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
        this.onCheckScrollStatus({
          reason: 'mount'
        });
      }
    }
  }, {
    key: "onUnmount",
    value: function onUnmount() {
      // `OnScrollTo` unmounts itself when it becomes hidden.
      // If a parent React component later calls `.onUnmount()` again
      // in `.componentWillUnmount()` then do nothing.
      if (!this.isMounted) {
        return;
      }

      this.isMounted = false;
      log('Unmount');

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      } else {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
      }
    }
  }, {
    key: "onCheckScrollStatus",
    value: function onCheckScrollStatus(reason) {
      if (this.getState().loading) {
        return;
      }

      log("Check scroll status (".concat(reason, ")"));

      if (this.isVisible()) {
        this.onScrollTo();
      }
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      var distance = this.options.distance;

      var _this$getElementCoord = this.getElementCoordinates(),
          top = _this$getElementCoord.top,
          bottom = _this$getElementCoord.bottom;

      var screen = getScreenBounds();
      return bottom >= screen.top - distance && top <= screen.bottom + distance;
    }
  }, {
    key: "getElementCoordinates",
    value: function getElementCoordinates() {
      var _this$getElement$getB = this.getElement().getBoundingClientRect(),
          top = _this$getElement$getB.top,
          height = _this$getElement$getB.height;

      return {
        top: top,
        bottom: top + height
      };
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
  }, {
    key: "setState",
    value: function setState(newState) {
      log('Set state', newState);
      this.state = _objectSpread({}, this.state, newState);
      log('New state', this.state);
      this.onStateChange(this.state);
    }
  }, {
    key: "onScrollTo",
    value: function onScrollTo() {
      log('On scroll to');
      this.disable();
      executeFunction(this._onScrollTo, this.onResult, this.onError);
    }
  }, {
    key: "disable",
    value: function disable() {
      log('Disable while loading');
      this.setState({
        loading: true
      });

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      var _this$getState = this.getState(),
          loading = _this$getState.loading,
          error = _this$getState.error;

      return !loading && !error;
    }
  }, {
    key: "enable",
    value: function enable() {
      log('Enable');
      this.setState({
        loading: undefined,
        error: undefined
      });

      if (this.intersectionObserver) {
        this.intersectionObserver.observe(this.getElement());
      } else {
        this.onCheckScrollStatus({
          reason: 're-enable'
        });
      }
    }
  }, {
    key: "retry",
    value: function retry() {
      if (!this.getState().error) {
        throw new Error('[on-scroll-to] No error');
      }

      log('Retry');
      this.enable();
    }
  }, {
    key: "hide",
    value: function hide() {
      log('Hide');
      this.setState({
        hidden: true
      });
      this.onUnmount();
    }
  }]);

  return OnScrollTo;
}();

export { OnScrollTo as default };

function executeFunction(func, onResult, onError) {
  try {
    var result = func();

    if (result && typeof result.then === 'function') {
      result.then(onResult, onError);
    } else {
      onResult(result);
    }
  } catch (error) {
    onError(error);
  }
}
//# sourceMappingURL=OnScrollTo.js.map